import React from "react";
import PropTypes from "prop-types";
import {
  Admonition,
  HSpacer,
  Modal,
  VSpacer
} from "@mqd/volt-base";
import { Button, Icon, Text } from "@mqd/volt-core/src";
import { Carousel } from "../carousel/index.js";
import css from "./announcements.module.css";
export function Announcements({ banner, children, title }) {
  const [isModalActive, setModalIsActive] = React.useState(false);
  const [isBannerActive, setBannerIsActive] = React.useState(false);
  const toggleModal = React.useCallback(
    (active) => {
      if (active === void 0)
        active = !isModalActive;
      setModalIsActive(active);
      if (!active) {
        localStorage.setItem("announcements", "banner");
      }
    },
    [isModalActive]
  );
  const toggleBanner = React.useCallback(
    (active) => {
      if (active === void 0)
        active = !isBannerActive;
      setBannerIsActive(active);
      if (!active) {
        localStorage.setItem("announcements", "none");
      }
    },
    [isBannerActive]
  );
  const closeBanner = React.useCallback(
    () => toggleBanner(false),
    [toggleBanner]
  );
  const openBanner = React.useCallback(
    () => toggleBanner(true),
    [toggleBanner]
  );
  const closeModal = React.useCallback(() => toggleModal(false), [toggleModal]);
  const openModal = React.useCallback(() => toggleModal(true), [toggleModal]);
  const DoneButton = () => {
    return /* @__PURE__ */ React.createElement(Button, { onClick: closeModal, autoFocus: true }, "Done");
  };
  React.useEffect(() => {
    const sessionState = localStorage.getItem("announcements");
    if (!sessionState) {
      openModal();
      openBanner();
    } else {
      if (sessionState === "banner") {
        closeModal();
        openBanner();
      }
      if (sessionState === "none") {
        closeModal();
        closeBanner();
      }
    }
  }, []);
  if (!isModalActive && !isBannerActive)
    return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isBannerActive && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Admonition, { type: "note" }, /* @__PURE__ */ React.createElement("header", { className: css.bannerHeader }, banner?.title && /* @__PURE__ */ React.createElement(Text, { mod: "h6" }, banner?.title), /* @__PURE__ */ React.createElement(Button, { link: true, onClick: closeBanner }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))), banner?.description && /* @__PURE__ */ React.createElement(Text, null, banner.description), /* @__PURE__ */ React.createElement(VSpacer, { factor: 1.5 }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { link: true, onClick: openModal, style: { padding: "0" } }, "View updates"), banner?.extraCTAs?.length && banner.extraCTAs.map((cta, i) => /* @__PURE__ */ React.createElement("span", { key: `announcements-cta-${i}` }, /* @__PURE__ */ React.createElement(HSpacer, { factor: 2, inline: true }), /* @__PURE__ */ React.createElement(
    Button,
    {
      link: true,
      style: { padding: "0" },
      onClick: cta.action
    },
    cta.text
  ))))), /* @__PURE__ */ React.createElement(VSpacer, { factor: 3 })), isModalActive && /* @__PURE__ */ React.createElement(
    Modal,
    {
      hideModal: closeModal,
      showHideModalButton: false,
      maxHeightVh: 100
    },
    /* @__PURE__ */ React.createElement("header", { className: css.modalHeader }, title && /* @__PURE__ */ React.createElement(Text, { mod: "h6" }, title), /* @__PURE__ */ React.createElement(Button, { link: true, onClick: closeModal }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))),
    /* @__PURE__ */ React.createElement(Carousel, { id: "announcements", DoneButton: /* @__PURE__ */ React.createElement(DoneButton, null) }, children)
  ));
}
Announcements.propTypes = {
  banner: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.node,
    extraCTAs: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        action: PropTypes.func
      })
    )
  }),
  children: PropTypes.any,
  title: PropTypes.string
};
Announcements.defaultProps = {
  banner: {},
  extraCTAs: [],
  title: ""
};
